import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import TranslatedText from '../../utils/Translate';
import { decode } from 'html-entities';
import {
  Button,
  Chip,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Fade,
  Avatar,
  Stack,
  IconButton
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';
import AudioFragment from '../../utils/AudioFragment';
import {
  RepeatcallsDecode,
  targetActiveTransfersDecode,
  TerminalstatusesDecode,
  TimeDecode
} from '../../utils/prepareJSON';
import axios from 'axios';
import { useAppDispatch } from '../../store';
import { logOut } from '../../utils/logOut';
import { LinearProgress, Box } from '@mui/material';
import NoDataOverlay from '../../utils/NoDataOverlay';
import Modal from '@mui/material/Modal';
import { playtexttostring } from '../../utils/ConversationTemplateSetupHelper';
import { green, blue } from "@mui/material/colors";
import { useSnackbar } from '../../utils/SnackbarContext';
import { set } from 'date-fns';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';


const SimplifiedTable = ({ rows, page, fetchDataUpdate = () => console.log("add update func to use fetch") }) => {
  const [data, setData] = useState([]);
  const language = useSelector((state) => state.auth.authData.language);
  const accesslevel = useSelector((state) => state.auth.authData.accesslevel);
  const [campaignsList, setCampaignsList] = useState([]);
  const [conversationFields, setConversationFields] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [openReSynthModal, setOpenReSynthModal] = React.useState(false);

  const { showSnackbar } = useSnackbar();

  // Добавляем состояние для посещённых DETAILS
  const [visitedDetailsIds, setVisitedDetailsIds] = useState(() => {
    const saved = localStorage.getItem('visitedDetailsIds');
    return saved ? JSON.parse(saved) : [];
  });

  // Сохраняем в localStorage при изменении
  useEffect(() => {
    localStorage.setItem('visitedDetailsIds', JSON.stringify(visitedDetailsIds));
  }, [visitedDetailsIds]);

  const handleDeleteModalOpen = (id) => {
    setOpenDeleteModal(id)
  };
  const handleDeleteModalClose = () => setOpenDeleteModal(false);

  const handleReSynthModalOpen = (id) => {
    setOpenReSynthModal(id)
  };

  const handleReSynthModalClose = () => setOpenReSynthModal(false);

  const dispatch = useAppDispatch();

  const Modalstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    maxWidth: 800,
    with: '40%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

   const truncateString = (s, w) => s.length > w ? s.slice(0, w) + "..." : s;

  const sortObjectProperties = (obj) => {
    const sortedEntries = Object.entries(obj).sort(([keyA], [keyB]) => {
      const priorityOrder = ['id', 'code', 'partnerbankcode', 'campaigncode', 'status', 'callrate', 'timeleft', 'cntleads', 'name', 'tool_choice', 'showsetuptopartner', 'conversationtemplatecode'];

      const indexA = priorityOrder.indexOf(keyA);
      const indexB = priorityOrder.indexOf(keyB);

      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });

    return Object.fromEntries(sortedEntries);
  };

  const sortArrayOfObjects = (arr) => {
    return arr.map(sortObjectProperties);
  };

  const processCallsData = (rowsData) => {
    if (!Array.isArray(rowsData) || rowsData.length === 0) return [];

    // Собираем все уникальные ключи из всех строк
    const allKeys = rowsData.reduce((keys, row) => {
      if (row.conversationfields) {
        const fields = row.conversationfields.split('|');
        fields.forEach(field => {
          const [key] = field.split('=');
          if (key && !keys.includes(key)) {
            keys.push(key);
          }
        });
      }
      return keys;
    }, []);

    // Обрабатываем каждую строку
    return rowsData.map(row => {
      const newRow = { ...row };

      // Инициализируем все ключи пустой строкой вместо null
      allKeys.forEach(key => {
        newRow[key] = '';
      });

      // Если есть conversationfields, заполняем значения
      if (row.conversationfields) {
        const fields = row.conversationfields.split('|');
        fields.forEach(field => {
          const [key, value] = field.split('=');
          if (key) {
            newRow[key] = value || ''; // Используем пустую строку, если значение не определено
          }
        });
      }

      return newRow;
    });
  };

  const normalizeData = (dataArray) => {
    const allKeys = dataArray.reduce((keys, obj) => {
      Object.keys(obj).forEach(key => {
        if (!keys.includes(key)) {
          keys.push(key);
        }
      });
      return keys;
    }, []);

    setHeaders(allKeys);


    // Нормализуем каждый объект, добавляя отсутствующие ключи со значением null
    return dataArray.map(obj => {
      const normalizedObj = { ...obj };
      allKeys.forEach(key => {
        if (!(key in normalizedObj)) {
          normalizedObj[key] = null;
        }
      });
      return normalizedObj;
    });
  };

  const renderProgressBar = (params) => {
    const value = parseFloat(params.value);
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress
            variant="determinate"
            value={value}
            sx={{
              height: 10,
              borderRadius: 5,
              '& .MuiLinearProgress-bar': {
                borderRadius: 5,
                backgroundColor: value <= 30 ? '#f44336' : value > 30 && value <= 50 ? '#FFB440' : '#4caf50',
              },
            }}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${value.toFixed(2)}%`}</Typography>
        </Box>
      </Box>
    );
  };

  const renderTableSkeleton = () => {
    const randomWidth = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

    const columnWidths = [
      [60, 100],
      [80, 120],
      [100, 150],
      [70, 110],
      [90, 130],
      [50, 90]
    ];

    const cellStyle = {
      paddingTop: '12px',
      paddingBottom: '12px',
      paddingLeft: '16px',
      paddingRight: '16px',
    };

    return (
      <TableContainer sx={{ height: '100%' }}>
        <Table size='small'>
          <TableHead>
            <TableRow>
              {columnWidths.map((widthRange, index) => (
                <TableCell key={index} sx={cellStyle}>
                  <Skeleton variant="text" width={randomWidth(...widthRange)} />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(10)].map((_, rowIndex) => (
              <TableRow key={rowIndex}>
                {columnWidths.map((widthRange, cellIndex) => (
                  <TableCell key={cellIndex} sx={cellStyle}>
                    <Skeleton variant="text" width={randomWidth(...widthRange)} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setShowTable(false);
      if (page === 'campaign') {
        await getCampaigns();
      }
      if (Array.isArray(rows) && rows.length > 0) {
        let processedRows = sortArrayOfObjects(rows);
        if (page === 'calls' || page === 'conversation') {
          processedRows = processCallsData(sortArrayOfObjects(rows.map(row => {
            const { conversationfields, ...rest } = row;
            return rest;
          })));
        }
        const convertedData = await convertCells(processedRows);
        const normalizedData = normalizeData(convertedData);

        setData(normalizedData);
      } else {
        setData([]);
      }
      setIsLoading(false);
      setShowTable(true);
    };

    fetchData();
  }, [rows, page]);

  const headerMapping = {
    partnerbankcode: 'PARTNER CODE',
    cgdatetoprocess: 'NEXT CONTACT DATE',
    branchname: 'BRANCH',
    officename: 'OFFICE',
    isclosed: 'CONTACT STATUS',
    leaddate: 'LEAD DATE',
    mobilephone: 'PHONE NUMBER',
    id: 'ID',
    clientid: 'CUSTOMER ID',
    customerlead: 'ID',
    lastname: 'LAST NAME',
    firstname: 'NAME',
    middlename: 'SURNAME',
    conversationtemplatecode: 'CONVERSATION TEMPLATE',
    conversationtemplatename: 'CONVERSATION TEMPLATE NAME',
    firstcall: 'DATE OF THE FIRST CALL',
    lastcall: 'LAST CALL DATE',
    countcalls: 'NUMBER OF CALLS',
    countconversations: 'NUMBER OF CONVERSATIONS',
    durationconversationsmin: 'CHARGED TIME, MIN',
    leadgroupcode: 'CODE',
    leadgroupname: 'NAME',
    calldate: 'CALL DATE',
    callstatus: 'CALL STATUS',
    campaigncode: 'CAMPAIGN CODE',
    field1name: 'FIELD 1 NAME',
    field1value: 'FIELD 1 VALUE',
    field1correct: 'FIELD 1 CORRECT',
    field2name: 'FIELD 2 NAME',
    field2value: 'FIELD 2 VALUE',
    field2correct: 'FIELD 2 CORRECT',
    countleads: 'COUNT LEADS',
    evalerror: 'MESSAGE',
    targetactivetransfers: 'TARGET NUMBER OF ACTS. TRANSFERS',
    maxactivetransfers: 'MAX NUMBER OF ACTS. TRANSFERS',
    parentcampaigncode: 'PARENT CAMPAIGN CODE',
    campaigndatestart: 'CAMPAIGN START DATE',
    campaignname: 'CAMPAIG NNAME',
    channelname: 'CHANNEL NAME',
    removefromleadgroup: 'REMOVE FROM LEADGROUP',
    leaddatefrom: 'LEAD DATE FROM',
    leaddateto: 'LEAD DATE TO',
    relativeleaddatefrom: 'DATE OF CONTACT IS RELATIVE FROM',
    relativeleaddateto: 'DATE OF CONTACT IS RELATIVE TO',
    campaignactivetime: 'CALL TIME (ROBOT)',
    clientactivetime: 'CALL TIME (CLIENT)',
    repeatcalls: 'CALL SCHEDULE',
    newleadsperdaylimit: 'DAILY LIMIT ON NEW CONTACTS',
    leadgroupcodefulfilled: 'GROUP OF PROCESSING CONTACTS',
    terminalstatusfield: 'TERMINAL STATUS FIELD',
    terminalstatuses: 'TERMINAL STATUSES',
    callrate: '% OF DIALING (LAST 1 THOUSAND CALLS)',
    language_client: 'CLIENT LANGUAGE',
    language_translation: 'TRANSLATION LANGUAGE',
    cntleads: 'CONTACTS LEFT = NUMBER OF CALLS',
    timeleft: 'TIME LEFT (MIN)',
    targetload: 'CALLS PER SEC',
    showsetuptopartner: 'SHOW SETUP TO PARTNER',
    ip: 'IP ADDRESS',
    recognitionvendor: 'RECOGNITION VENDOR',
    voicecloningvendor: 'VOICE CLONING VENDOR',
    voicecode: 'VOICE CODE',
    prerecordedvoicename: 'PRERECORDED VOICE',
    pitchprerecorded: 'PITCH PRERECORDED',
    tempoprerecorded: 'TEMPO PRERECORDED',
    backgroundsoundcode: 'BACKGROUND SOUND CODE',
    examplesoundcode: 'EXAMPLE SOUND CODE',
    datetimeproduced: 'CREATION DATE',
    voicename: 'VOICE NAME',
    audiolength: 'AUDIO LENGTH',
    conversationwhen: 'DATE OF CONVERSATION',
    calleridname: 'CALLER NAME',
    calleridnum: 'CALLER NUM',
    uniqueid: 'DETAILS/ID',
    contractnumber: 'CONTRACT NUMBER',
    evalerrorpresent: 'MESSAGE EXISTENCE',
    shortdescription: 'SHORT DESCRIPTION',
    commandwhen: 'COMMAND TIME',
    recordnumber: 'RECORD NUMBER',
    lastinputvalue: 'LAST INPUT VALUE',
    lastinputvalueword: 'LAST INPUT WORD',
    fieldname: 'FIELD NAME',
    fieldvalue: 'FIELD VALUE',
    fieldcorrect: 'FIELD CORRECT',
    countconversationhistory: 'NUMBER OF EXECUTED COMMANDS',
    endtime: 'END TIME',
    templatepart: 'TEMPLATE PART',
    conversationhistoryfields: 'CONVERSATION FIELDS',
    conversationdate: 'CONVERSATION DATE',
    durationsec: 'DURATION (SEC)',
    callratereport: 'CALL RATE',
    commanddetails: 'TRANSCRIPT',
    vad_type: 'VOICE ACTIVITY DETECTION TYPE',
    tool_choice: 'TOOL CHOICE',
    partsids: 'AUDIO PARTS IDS',
  };

  const convertCells = async (data) => {
    const companyL = page == 'campaign' ? await getCampaigns() : []
    

    return data.map((row) => {
      let convertedRow = { ...row };
      if (page === 'settingsupconversationtemplate') {
        convertedRow.templatepart =
          row.templatepart == '1'
            ? 'Background'
            : row.templatepart == '2'
              ? 'Conversation'
              : 'Call management';
        convertedRow.enabled = row.enabled == '1' ? 'Yes' : 'No';
        convertedRow.commanddetails = row.commanddetails ? Object.keys(JSON.parse(row.commanddetails))[0] == 'play' ? playtexttostring(JSON.parse(row.commanddetails).play.playtext) : '' : ''
      }
      if (page === 'contact') {
        convertedRow.isclosed = row.isclosed == '0' ? 'Open' : 'Closed';
      }

      if (page === 'analysistemplate' || page === 'conversationtemplate' || page === 'wordgroup' || page === 'aiprompt') {
        convertedRow.showsetuptopartner = row.showsetuptopartner == '0' ? 'No' : 'Yes';
      }
      if (page === 'conversationdetail') {
        convertedRow.templatepart = row.templatepart == '1' ? 'Background' : 'Conversation';
      }
      if (page === 'did') {
        convertedRow.enabled = row.enabled == '0' ? 'No' : 'Yes';
      }
      if (page === 'aiprompt') {
        if (!row.partner) {
          convertedRow.partner = 'Only Operator'
        }
        else if (row.partner == '0') {
          convertedRow.partner = 'All'
        }
        else {
          convertedRow.partner = row.partnerbankcode
        }

      }
      if (page === 'wordgroup') {
        convertedRow.partnerbankcode = row.partnerbankcode != null && row.partnerbankcode != '' ? row.partnerbankcode : 'General';
        convertedRow.conversationtemplatecode = row.conversationtemplatecode != null && row.conversationtemplatecode != '' ? row.conversationtemplatecode : 'General';
      }

      if (page === 'campaign') {
        const statusMapping = {
          '0': 'Stopped',
          '1': 'Launched',
          '2': 'Stopped by a robot - calls do not go through!',
          '3': 'Launched - no contacts',
          '4': 'Launched - break'
        };

        convertedRow = {
          ...row,
          isclosed: row.isclosed == '0' ? 'Open' : row.isclosed == '1' ? 'Closed' : 'Any',
          status: statusMapping[row.status],
          removefromleadgroup: row.removefromleadgroup == '1' ? 'Remove' : 'Keep',
          emails: row.emails ? JSON.parse(row.emails).join(', ') : '',
          targetactivetransfers: targetActiveTransfersDecode(
            row.targetactivetransfers != null
              ? row.targetactivetransfers
              : { campaigns: [], limit: '' },
            companyL
          ),
          maxactivetransfers: targetActiveTransfersDecode(
            row.maxactivetransfers != null ? row.maxactivetransfers : { campaigns: [], limit: '' },
            companyL
          ),
          campaignactivetime: TimeDecode(row.campaignactivetime),
          clientactivetime: TimeDecode(row.clientactivetime),
          repeatcalls: RepeatcallsDecode(row.repeatcalls),
          newleadsperdaylimit: JSON.parse(row.newleadsperdaylimit).limit,
          terminalstatuses: TerminalstatusesDecode(row.terminalstatuses)
        };
      }
      return convertedRow;
    });
  };

  async function getCampaigns(params = {}) {
    try {
      const response = await axios.get(`https://cardgarantsales.com/restapi/campaign`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('access_token')
        },
        params: params
      });
      if (response.data !== null) {
        if (typeof response.data === 'object') {
          const convertedList = response.data.reduce((acc, item) => {
            acc[item.id] = item.campaigncode;
            return acc;
          }, {});
          setCampaignsList(convertedList);
          return convertedList
        } else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error');
      }
    } catch (error) {
      console.log(error);
      if (error.message === 'Request failed with status code 401') {
        logOut(dispatch);
      } else if (error.code === 'ERR_NETWORK') {
        showSnackbar('ERROR NETWORK', 'error');
      }
      return {};
    }
  }

  const renderHeader = () => {
    if (!headers.length) return null;

    return (
      <TableRow>
        {page === 'loginreport' && (
          <TableCell key="USERNAME" style={{ whiteSpace: 'nowrap' }} ><TranslatedText text="USERNAME" /></TableCell>
        )}
        {page !== 'calls' &&
          page !== 'conversation' &&
          !page.includes('report') &&
          page !== 'chart' &&
          page !== 'optimizationtemplate' &&
          page !== 'conversationdetail' &&
          page !== 'analysistemplate' && <TableCell key="EDIT" style={{ whiteSpace: 'nowrap' }} />}
        {(page === 'analysistemplate' && accesslevel != 3) && (
          <TableCell key="EDIT" style={{ whiteSpace: 'nowrap' }} />
        )}
        {page === 'prerecordedaudiosnippet' && (
          <>
            <TableCell key="COPY" style={{ whiteSpace: 'nowrap' }} />
            <TableCell key="DELETE" style={{ whiteSpace: 'nowrap' }} />
            <TableCell key="AUDIO" style={{ whiteSpace: 'nowrap' }} />
          </>
        )}
        {page === 'synthaudiofragment' && (
          <>
            <TableCell key="RESYNTHESIZE" style={{ whiteSpace: 'nowrap' }} />
            <TableCell key="DELETE" style={{ whiteSpace: 'nowrap' }} />
            <TableCell key="AUDIO" style={{ whiteSpace: 'nowrap' }} />
          </>
        )}
        {page === 'settingsupconversationtemplate' && (
          <>
            <TableCell key="COPY" style={{ whiteSpace: 'nowrap' }} />
            {accesslevel != 5 &&
              <TableCell key="REQUEST" style={{ whiteSpace: 'nowrap' }} />
            }
          </>

        )}
        {page === 'conversationtemplate' && (
          <>
            {accesslevel == 5 &&
              <TableCell key="COPY" style={{ whiteSpace: 'nowrap' }} />
            }
          </>
        )}
         {page === 'aimodelsallowed' && (
          <>
              <TableCell key="DELETE" style={{ whiteSpace: 'nowrap' }} />
          </>
        )}
        {page === 'campaign' && (
          <TableCell key="DELETE" style={{ whiteSpace: 'nowrap' }} />
        )}
        {page === 'conversationdetail' && (
          <>
            <TableCell key="AUDIO" style={{ whiteSpace: 'nowrap' }} />
            {accesslevel != 5 &&
              <TableCell key="REQUEST" style={{ whiteSpace: 'nowrap' }} />
            }
            <TableCell key="ALLCURRENTFIELDS" style={{ whiteSpace: 'nowrap' }} />
          </>
        )}
        {(page == 'calls' || page == "conversation") && !page.includes('report') && page != 'chart' && page != 'optimizationtemplate' && (
          <>
            {page == "conversation" && <TableCell key="INDICATOR" style={{ whiteSpace: 'nowrap' }} ></TableCell>}
            <TableCell key="AUDIO" style={{ whiteSpace: 'nowrap' }} ><TranslatedText text="AUDIO" /></TableCell>
            <TableCell key="EDIT" style={{ whiteSpace: 'nowrap' }} ><TranslatedText text="EDIT" /></TableCell>
            <TableCell key="DETAILS" style={{ whiteSpace: 'nowrap' }} ><TranslatedText text="DETAILS" /></TableCell>
            {accesslevel != 5 &&
              <TableCell key="REQUESTS" style={{ whiteSpace: 'nowrap' }} ></TableCell>
            }
          </>

        )}

        {headers.filter((key) => {
          if (page === "analysistemplate") {
            if (accesslevel == 5) {
              return key !== "analyzefreeinputdetails" && key !== "partner";
            }
            return key !== "analyzefreeinputdetails" && key !== "partner" && key !== "showsetuptopartner" && key !== "partnerbankcode";
          } else if (page === "loginreport") {
            return key !== "action" && key !== "user" && key !== "username";
          } else if (page === "branch" || page === "did" || page === "contactgroup") {
            return key !== "partner";
          } else if (page === "wordgroup") {
            if (accesslevel == 5) {
              return key !== "partner" && key !== "conversationtemplate";
            }
            return key !== "partner" && key !== "conversationtemplate" && key !== "showsetuptopartner" && key !== "partnerbankcode";
          } else if (page === "conversationtemplate") {
            if (accesslevel == 5) {
              return key !== "partner" && key !== "voicecode";
            }
            return key !== "partner" && key !== "voicecode" && key !== "showsetuptopartner";
          }
          else if (page === "settingsupconversationtemplate") {
            return key !== "command";
          }
          else if (page === "aiprompt") {
            if (accesslevel != 5) {
              return key !== "prompt" && key !== "partnerbankcode" && key != 'showsetuptopartner' && key != 'partner';
            }
            else return key !== "prompt" && key !== "partnerbankcode";

          }
          else {
            return true;
          }
        }).map((key) => (
          <TableCell key={key} style={{ whiteSpace: 'nowrap' }}>
            {(page != 'calls' && page != 'conversation') ? <TranslatedText text={headerMapping[key] || key.toUpperCase()} style={{ fontSize: '0.875rem' }} /> : <Typography style={{ fontSize: '0.875rem' }}>{headerMapping[key] || key.toUpperCase()}</Typography>}
          </TableCell>
        ))}
      </TableRow>
    );
  };

  const renderActionButton = (type, row) => {
    switch (type) {
      case 'EDIT':
        if (row.showsetuptopartner == 'Yes' || accesslevel == 5 || page === 'settingsupconversationtemplate' || page === 'contact' || page === 'contactgroup' || page === 'campaign' || page === 'did' || page == 'prerecordedaudiosnippet' || page == 'synthaudiofragment' || page == 'office' || page == 'branch' || page == 'knowledgebase' || page == 'partner' || page == 'user') {
          // console.log(row.command);

          return (
            <Link to={`/${page}?id=${row.id}&type=edit`}>
              <Button variant="text" size="small">
                <TranslatedText text="Edit" />
              </Button>
            </Link>
          );
        }
        else {
          return ''
        }
      case 'EDITFIELDS':
        return (
          <Link to={`/editconversationfields?id=${row.uniqueid}`}>
            <Button variant="text" size="small">
              <TranslatedText text="Edit" />
            </Button>
          </Link>
        );
      case 'COPY':
        return (
          <Link to={`/${page}?id=${row.id}&type=copy`}>
            <Button variant="text" size="small">
              <TranslatedText text="Copy" />
            </Button>
          </Link>
        );
      case 'DELETE':
        return (
          <Button variant="text" size="small" onClick={() => handleDeleteModalOpen(row.id)}>
            <TranslatedText text="DELETE" />
          </Button>
        );
      case 'RESYNTHESIZE':
        return (
          <Button variant="text" size="small" onClick={() => handleReSynthModalOpen(row.id)}>
            <TranslatedText text="RESYNTHESIZE" />
          </Button>
        );
      case 'DETAILS':
        // Проверяем, был ли посещён DETAILS для этого uniqueid
        const isVisited = visitedDetailsIds.includes(row.uniqueid);
        return (
          <Link
            to={`/conversationdetails?uniqueid=${row.uniqueid}`}
            onClick={() => {
              if (!isVisited) {
                const updated = [...visitedDetailsIds, row.uniqueid];
                setVisitedDetailsIds(updated);
                localStorage.setItem('visitedDetailsIds', JSON.stringify(updated));
              }
            }}
          >
            <Button
              variant="text"
              size="small"
              color={isVisited ? '' : 'primary'}
            >
              <TranslatedText text="Details" />
            </Button>
          </Link>
        );
      case 'ALLCURRENTFIELDS':
        return (
          <Link to={`/conversationdetail?id=${row.id}&type=edit`}>
            <Button variant="text" size="small">
              <TranslatedText text="ALL CURRENT FIELDS" />
            </Button>
          </Link>
        );
      case 'USERNAME':
        return (
          <Link to={`/user?id=${row.user}&type=profile`}>
            <Button sx={{ textTransform: 'none', userSelect: 'auto' }} variant="text" size="small">
              {row.username}
            </Button>
          </Link>
        );
      case 'REQUEST_CALL_CONVERSATION':
        return (
          <Tooltip title={<TranslatedText text={"Create a support request"} />} placement="top-start">
            <Link to={`/userrequest?subject=Conversation Template: "${row.conversationtemplatecode}", ID: ${row.uniqueid}`}>
              <IconButton sx={{ opacity: '0.7' }} color="primary">
                <AnnouncementOutlinedIcon />
              </IconButton>
            </Link>
          </Tooltip>
        );
      case 'REQUEST_DETAILS':
        return (
          <Tooltip title={<TranslatedText text={"Create a support request"} />} placement="top-start">
            <Link to={`/userrequest?subject=Conversation Template: "${row.conversationtemplatecode}", ID: ${row.uniqueid}, Command: ${row.recordnumber} - ${row.description}`}>
              <IconButton sx={{ opacity: '0.7' }} color="primary">
                <AnnouncementOutlinedIcon />
              </IconButton>
            </Link>
          </Tooltip>
        );
      case 'REQUEST_COMMANDS':
        return (
          <Tooltip title={<TranslatedText text={"Create a support request"} />} placement="top-start">
            <Link to={`/userrequest?subject=Conversation Template: "${row.conversationtemplatecode}", Command: ${row.recordnumber} - ${row.description}`}>
              <IconButton sx={{ opacity: '0.7' }} color="primary">
                <AnnouncementOutlinedIcon />
              </IconButton>
            </Link>
          </Tooltip>
        );
      default:
        return null;
    }
  };

  // const handleDelete = (id) => {
  //   console.log(`Delete item with id: ${id}`);
  // };

  async function handleDelete(id) {
    try {
      const response = await axios.delete(`https://cardgarantsales.com/restapi/${page == 'prerecordedaudiosnippet' ? 'prerecordedspeech' : page == 'synthaudiofragment' ? 'synthesizedspeech' : page}/` + id, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + localStorage.getItem('access_token')
        },
      })
      if (page === 'synthaudiofragment') {
        fetchDataUpdate();
      }
      else {
        setData(data.filter((row) => row.id !== id))
      }

    } catch (error) {
      console.log(error);
      if (error.code === "ERR_BAD_REQUEST") {
        logOut(dispatch)
      }
      else if (error.code === "ERR_NETWORK") {
        showSnackbar('ERROR NETWORK', 'error')
      }
    }
    handleDeleteModalClose()
  }

  // async function handleReSynth(id) {
  //   try {
  //     const response = await axios.patch(`https://cardgarantsales.com/restapi/synthesizedspeech/` + id, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         "Authorization": "Bearer " + localStorage.getItem('access_token')
  //       },
  //     })
  //   } catch (error) {
  //     console.log(error);
  //     if (error.code === "ERR_BAD_REQUEST") {
  //       // logOut(dispatch)
  //     }
  //     else if (error.code === "ERR_NETWORK") {
  //       showSnackbar('ERROR NETWORK', 'error')
  //     }
  //   }
  // }

  async function handleReSynth(id) {
    setOpenReSynthModal(false);
    try {
      const response = await axios.patch(
        "https://cardgarantsales.com/restapi/synthesizedspeech/" + id,
        null,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('access_token')
          }
        }
      );
      console.log(response.data);
      fetchDataUpdate();
    } catch (error) {
      console.log(error);
      if (error.code === "ERR_BAD_REQUEST") {
        // logOut(dispatch)
      }
      else if (error.code === "ERR_NETWORK") {
        showSnackbar('ERROR NETWORK', 'error')
      }
    }
  }

  const renderCellContent = (key, value) => {
    if (key === 'callrate' || key === 'callratereport') {
      return renderProgressBar({ value });
    } else if ((page === 'conversationdetail' || page === 'optimizationtemplate') && key === 'evalerror') {
      const getStatus = (value) => {
        if (!value || value.trim() === "") {
          return { color: "success.main", label: "OK", icon: <CheckCircleIcon sx={{ color: "success.main" }} fontSize="small" /> };
        }
        if (value.toLowerCase().includes("внимание") || value.toLowerCase().includes("ошибка") || value.toLowerCase().includes("attention") || value.toLowerCase().includes("error")) {
          return { color: "warning.main", label: "Warning", icon: <ReportProblemIcon sx={{ color: "warning.main" }} fontSize="small" /> };
        }
        return { color: "info.main", label: "Message", icon: <ReportGmailerrorredIcon sx={{ color: "info.main" }} fontSize="small" /> };
      };

      const status = getStatus(value);

      return (
        <Box
          sx={{
            borderLeft: `4px solid ${status.color}`,
            bgcolor: "background.paper",
            boxShadow: 1,
            borderRadius: 2,
            p: 1.5,
            width: "100%",
            maxWidth: page === 'optimizationtemplate' ? 1200 : '100%',
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxHeight: 460,
            overflow: "hidden",
          }}
        >
          <Box display="flex" alignItems="center" gap={0.8}>
            {status.icon}
            <Typography variant="body2" color={status.color} fontWeight="bold">
              {status.label}
            </Typography>
          </Box>
          {value && (
            <Box dangerouslySetInnerHTML={{ __html: decode(value) }} sx={{ maxHeight: 450, overflowY: "auto", maxWidth: page === 'optimizationtemplate' ? '100%' : 500 }} />
          )}
        </Box>
      );
    } else if (page === 'conversationdetail' && key === 'transcript') {
      if (value.includes('=>')) {
        return (
          <Chip
            color="success"
            label={value.replace('=>', '')}
            size="small"
            icon={<SmartToyIcon />}
          />
        );
      } else if (value.includes('<=')) {
        return (
          <Chip
            color="info"
            label={value.replace('<=', '')}
            size="small"
            icon={<RecordVoiceOverIcon />}
          />
        );
      }
      else {
        return '';
      }
    }
    else if (page === 'conversationdetail' && key === 'partsids') {
      if (value && value !== '') {
        return (value.match(/[sp]\d+/g) || []).map((part) => {
          if (part.startsWith('s')) {
            return (
              <Link to={`/synthaudiofragments?id=${part.replace('s', '')}`}>
                <Chip
                  key={part}
                  // color="success"
                  label={part.replace('s', '')}
                  size="small"
                  icon={<GraphicEqIcon />}
                  sx={{ marginRight: 0.5 }}
                />
              </Link>
            );
          } else if (part.startsWith('p')) {
            return (
              <Link to={`/prerecordedaudiosnippets?id=${part.replace('p', '')}`}>
                <Chip
                  key={part}
                  // color="success"
                  label={part.replace('p', '')}
                  size="small"
                  icon={<GraphicEqIcon />}
                  sx={{ marginRight: 0.5 }}
                />
              </Link>
            );
          }
          return '';
        });
      } else {
        return '';
      }
    }
    else if (page === 'knowledgebase' && key === 'tags') {
      if (value && value != '') {
        return (
           truncateString(value, 100)
        );
      }
      else {
        return '';
      }
    }
    else if (page === 'knowledgebase' && key === 'content') {
      if (value && value != '') {
        return (
           truncateString(value, 100)
        );
      }
      else {
        return '';
      }
    }
     else if (page === 'knowledgebase' && key === 'name') {
      if (value && value != '') {
        return (
           truncateString(value, 150)
        );
      }
      else {
        return '';
      }
    }
    else {
      return value;
    }
  };


  const getRowsColor = (row) => {
    if (page === 'prerecordedaudiosnippet') {
      if ((row.audiolength === null || row.audiolength === '0' || row.audiolength === '0.0') && (row.transcript != '' && row.transcript != null)) {
        return '#f1c0c1' // red
      }
      if ((row.audiolength === null || row.audiolength === '0' || row.audiolength === '0.0') && (row.transcript == '' || row.transcript === null)) {
        return '#f9d2b3' // yellow
      }
      if ((row.audiolength !== null || row.audiolength != '0' || row.audiolength != '0.0')) {
        return '#c0d8c1' // green
      }
    }
    else if (page === 'settingsupconversationtemplate') {
      if (((Math.floor(row.recordnumber / 1000)) % 2 === 0)) {
        return '#c0d8c1' // green
      }
      else {
        return '#b3dcf2' // blue
      }
    }
    else return 'none'
  }

  const renderRows = () => {
    if (!data.length) return null;



    return data.map((row, index) => {

      return (
        <TableRow key={index} sx={{ background: getRowsColor(row) }}>
          {page !== 'calls' &&
            page !== 'conversation' &&
            !page.includes('report') &&
            page !== 'chart' &&
            page !== 'optimizationtemplate' &&
            page !== 'conversationdetail' &&
            page !== 'prerecordedaudiosnippet' &&
            page !== 'synthaudiofragment' &&
            page !== 'analysistemplate' && (
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('EDIT', row)}</TableCell>
            )}

          {(page === 'analysistemplate' && accesslevel != 3) && (
            <>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('EDIT', row)}</TableCell>
            </>
          )}
          {page === 'prerecordedaudiosnippet' && (
            <>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('EDIT', row)}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('COPY', row)}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('DELETE', row)}</TableCell>
              <TableCell>
                {row.audiolength !== null && row.audiolength !== '0' && <AudioFragment key={row.id} id={row.id} />}
              </TableCell>
            </>
          )}
          {page === 'synthaudiofragment' && (
            <>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('EDIT', row)}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('RESYNTHESIZE', row)}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('DELETE', row)}</TableCell>
              <TableCell>
                {row.audiolength !== null && row.audiolength !== '0' && row.audiolength !== '0.0' && <AudioFragment key={row.id} id={row.id} type={'synthesizedspeech'} />}
              </TableCell>
            </>
          )}
          {page === 'settingsupconversationtemplate' && (
            <>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('COPY', row)}</TableCell>
              {accesslevel != 5 &&
                <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('REQUEST_COMMANDS', row)}</TableCell>
              }
            </>
          )}
          {page === 'conversationtemplate' && (
            <>
              {accesslevel == 5 &&
                 <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('COPY', row)}</TableCell>
              }
            </>
          )}
          {page === 'aimodelsallowed' && (
            <>
                 <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('DELETE', row)}</TableCell>
            </>
          )}
          {page === 'calls' && (
            <>
              <TableCell>
                {row.id && <AudioFragment id={row.id} type={'recordedconversation'} />}
              </TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{row.id && renderActionButton('EDITFIELDS', row)}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{row.id && renderActionButton('DETAILS', row)}</TableCell>
              {accesslevel != 5 &&
                <TableCell>
                  {row.id && renderActionButton('REQUEST_CALL_CONVERSATION', row)}
                </TableCell>}
            </>
          )}
          {page === 'conversation' && !page.includes('report') && page !== 'chart' && page !== 'optimizationtemplate' && (
            <>
              <TableCell>
                {(row.endtime != null && row.endtime != '') ?
                  <Box sx={{
                    borderRadius: 90, width: 12, height: 12,
                    background: blue[100]

                  }} /> :
                  <Box className="breath-animation" sx={{
                    borderRadius: 90, width: 12, height: 12,
                    background: green[500]

                  }} />}
              </TableCell>
              <TableCell>
                {row.id && <AudioFragment id={row.id} type={'recordedconversation'} />}
              </TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{row.id && renderActionButton('EDITFIELDS', row)}</TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{row.id && renderActionButton('DETAILS', row)}</TableCell>
              {accesslevel != 5 &&
                <TableCell>
                  {row.id && renderActionButton('REQUEST_CALL_CONVERSATION', row)}
                </TableCell>}
            </>
          )}
          {page === 'campaign' && (
            <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('DELETE', row)}</TableCell>
          )}
          {page === 'conversationdetail' && (
            <>
              <TableCell>
                {row.conversation && <AudioFragment id={row.conversation} type={'recordedconversation'} />}
              </TableCell>
              <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('ALLCURRENTFIELDS', row)}</TableCell>
              {accesslevel != 5 &&
                <TableCell>
                  {row.id && renderActionButton('REQUEST_DETAILS', row)}
                </TableCell>}
            </>
          )}
          {page === 'loginreport' && (
            <TableCell style={{ whiteSpace: 'nowrap' }}>{renderActionButton('USERNAME', row)}</TableCell>
          )}
          {headers.filter((key) => {
            if (page === "analysistemplate") {
              if (accesslevel == 5) {
                return key !== "analyzefreeinputdetails" && key !== "partner";
              }
              return key !== "analyzefreeinputdetails" && key !== "partner" && key !== "showsetuptopartner" && key !== "partnerbankcode";
            } else if (page === "loginreport") {
              return key !== "action" && key !== "user" && key !== "username";
            } else if (page === "branch" || page === "did" || page === "contactgroup") {
              return key !== "partner";
            } else if (page === "wordgroup") {
              if (accesslevel == 5) {
                return key !== "partner" && key !== "conversationtemplate" && key !== "groupdetails";
              }
              return key !== "partner" && key !== "conversationtemplate" && key !== "groupdetails" && key !== "showsetuptopartner" && key !== "partnerbankcode";
            } else if (page === "conversationtemplate") {
              if (accesslevel == 5) {
                return key !== "partner" && key !== "voicecode";
              }
              return key !== "partner" && key !== "voicecode" && key !== "showsetuptopartner";
            } else if (page === "settingsupconversationtemplate") {
              return key !== "command";
            }
            else if (page === "aiprompt") {
              if (accesslevel != 5) {
                return key !== "prompt" && key !== "partnerbankcode" && key != 'showsetuptopartner' && key != 'partner';
              }
              else return key !== "prompt" && key !== "partnerbankcode";

            } else {
              return true;
            }
          }).map((key) => (
            <TableCell key={key} style={{ whiteSpace: 'nowrap' }}>
              {renderCellContent(key, row[key] ? row[key] : '')}
            </TableCell>
          ))}

          {page === 'wordgroup' && (
            <TableCell style={{ whiteSpace: 'nowrap' }}>
              <Stack spacing={0.5}>
                {
                  Array.isArray(JSON.parse(row.groupdetails)) ? <Chip sx={{ justifyContent: 'flex-start' }} label={row.groupdetails} avatar={<Avatar>{'ru'}</Avatar>} />
                    :
                    Object.entries(JSON.parse(row.groupdetails)).map((langtext) => {
                      if (JSON.stringify(langtext[1]) != '') {
                        return (
                          <Chip sx={{ justifyContent: 'flex-start' }} label={JSON.stringify(langtext[1])} avatar={<Avatar>{langtext[0]}</Avatar>} />
                        )
                      }
                      else {
                        return ''
                      }

                    })}
              </Stack>
            </TableCell>
          )}
        </TableRow>
      )
    });
  };

  if (isLoading && page == 'campaigns') {
    return renderTableSkeleton();
  }

  if (!isLoading && (!data || data.length === 0)) {
    return <NoDataOverlay />;
  }


  return (
    <>
      <Fade in={showTable} timeout={300}>
        <TableContainer>
          <Table size='small' stickyHeader={true}>
            <TableHead>{renderHeader()}</TableHead>
            <TableBody>{renderRows()}</TableBody>
          </Table>
        </TableContainer>
      </Fade>
      <Modal
        open={openDeleteModal}
        onClose={handleDeleteModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Modalstyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <TranslatedText text="Delete object" />
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TranslatedText text="Are you sure you want to delete the object with ID" /> {openDeleteModal}?
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: "space-between", paddingTop: 2 }}>
            <Button onClick={handleDeleteModalClose}><TranslatedText text="Cancel" /></Button>
            <Button onClick={() => handleDelete(openDeleteModal)} color='error'><TranslatedText text="Delete" /></Button>
          </Box>
        </Box>
      </Modal>
      {
        page === 'synthaudiofragment' &&
        <Modal
          open={openReSynthModal}
          onClose={handleDeleteModalClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...Modalstyle, maxWidth: 500, }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <TranslatedText text="Are you sure you want to resynthesise audio fragment?" />
            </Typography>
            {/* <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center' }}>
              <TranslatedText text="Are you sure you want to delete the object with ID" /> {openReSynthModal}?
              <AudioFragment id={openReSynthModal} type={'synthesizedspeech'} />
            </Typography> */}
            <Box sx={{ display: 'flex', justifyContent: "space-between", paddingTop: 2 }}>
              <Button color='error' onClick={handleReSynthModalClose}><TranslatedText text="Close" /></Button>
              <Button onClick={() => handleReSynth(openReSynthModal)}><TranslatedText text="Resynthesize" /></Button>
            </Box>
          </Box>
        </Modal>
      }
    </>
  );
};

export default SimplifiedTable;
